

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateEvent
// ====================================================

export interface CreateEvent_createEvent {
  __typename: "Event";
  website: string;  // The WithJoy URL namespace for this Event, eg. 'withjoy.com/website'
  eventId: string;  // The ID of this Event's Firebase Document
}

export interface CreateEvent {
  createEvent: CreateEvent_createEvent | null;
}

export interface CreateEventVariables {
  ownerFirstName: string;
  ownerLastName: string;
  fianceeFirstName: string;
  fianceeLastName: string;
  calendarDate?: CalendarDate | null;
  date?: number | null;
  tzid?: string | null;
  place?: string | null;
  placeId?: string | null;
  lat?: number | null;
  lng?: number | null;
  template?: string | null;
  theme?: string | null;
  font?: string | null;
  graphicAccent?: string | null;
  enableTranslucentEffect: boolean;
  useSuggestedBackgroundColor: boolean;
  useWeddingColor: boolean;
  paletteId?: string | null;
  paletteName?: string | null;
  accentColor?: (number | null)[] | null;
  baseColor?: (number | null)[] | null;
  accentText?: (number | null)[] | null;
  baseText?: (number | null)[] | null;
  accentLightText: boolean;
  baseLightText: boolean;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: EventStyle
// ====================================================

export interface EventStyle_event_style {
  __typename: "EventStyle";
  id: string;
  layout: Layout;
  accent: string;
  theme: string;
}

export interface EventStyle_event {
  __typename: "Event";
  id: string;
  style: EventStyle_event_style;  // Design & presentational style information for this Event
}

export interface EventStyle {
  event: EventStyle_event | null;
}

export interface EventStyleVariables {
  id: string;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: Handle
// ====================================================

export interface Handle_handle_settings {
  __typename: "EventSettings";
  hideEventCountdown: boolean;
}

export interface Handle_handle_info_qanda {
  __typename: "EventQanda";
  id: string;
  type: QandaType;
  question: string;
  answer: string;
}

export interface Handle_handle_info_registry {
  __typename: "Registry";
  id: string;
  name: string;
  url: string;       // The URL to the Registry website
  imageUrl: string;  // The image to display as the Registry's avatar
}

export interface Handle_handle_info_toBeAnnouncedSchedule {
  __typename: "EventSchedule";
  id: string;
  name: string;
  description: string | null;
  dressCode: string | null;
  location: string | null;
  showMap: boolean;
  placeId: string | null;
  startTime: string | null;
  endTime: string | null;
}

export interface Handle_handle_info_formattedSchedule_items {
  __typename: "EventSchedule";
  id: string;
  name: string;
  description: string | null;
  dressCode: string | null;
  startTime: string | null;
  endTime: string | null;
  timezone: string | null;
  location: string | null;
  showMap: boolean;
}

export interface Handle_handle_info_formattedSchedule {
  __typename: "FormattedSchedule";
  day: number;
  month: number;
  year: number;
  date: string;
  dateString: string;
  items: Handle_handle_info_formattedSchedule_items[];
}

export interface Handle_handle_info_travel_EventTravelBookingType {
  __typename: "EventTravelBookingType";
  id: string;
  name: string;
  address: string | null;
  bookingType: string | null;
  startDate: string | null;
  endDate: string | null;
  timezone: string | null;
  latitude: number | null;
  longitude: number | null;
  placeId: string | null;
}

export interface Handle_handle_info_travel_Flight {
  __typename: "Flight";
  id: string;
  name: string;
  url: string | null;
  code: string | null;
  notes: string | null;
}

export interface Handle_handle_info_travel_RentalCar {
  __typename: "RentalCar";
  id: string;
  name: string;
  address: string | null;
  telephone: string | null;
  notes: string | null;
  url: string | null;
}

export interface Handle_handle_info_travel_Taxi {
  __typename: "Taxi";
  id: string;
  name: string;
  address: string | null;
  telephone: string | null;
  notes: string | null;
  url: string | null;
}

export interface Handle_handle_info_travel_EventTravelNote {
  __typename: "EventTravelNote";
  id: string;
  name: string;
  notes: string | null;
}

export interface Handle_handle_info_travel_Train {
  __typename: "Train";
  id: string;
  name: string;
  address: string | null;
  telephone: string | null;
  notes: string | null;
  url: string | null;
}

export interface Handle_handle_info_travel_Ferry {
  __typename: "Ferry";
  id: string;
  name: string;
  address: string | null;
  telephone: string | null;
  url: string | null;
  notes: string | null;
}

export interface Handle_handle_info_travel_Shuttle_items {
  __typename: "ShuttleItem";
  id: string;
  note: string | null;
  dateStart: string | null;
  dateEnd: string | null;
}

export interface Handle_handle_info_travel_Shuttle {
  __typename: "Shuttle";
  id: string;
  name: string;
  notes: string | null;
  items: Handle_handle_info_travel_Shuttle_items[];
}

export interface Handle_handle_info_travel_EventTravelList_items {
  __typename: "EventTravelListItem";
  id: string;
  title: string | null;
  url: string | null;
}

export interface Handle_handle_info_travel_EventTravelList {
  __typename: "EventTravelList";
  id: string;
  name: string;
  items: Handle_handle_info_travel_EventTravelList_items[];
}

export interface Handle_handle_info_travel_Hotel {
  __typename: "Hotel";
  id: string;
  name: string;
  address: string | null;
  telephone: string | null;
  url: string | null;
  notes: string | null;
}

export interface Handle_handle_info_travel_Tent {
  __typename: "Tent";
  id: string;
  name: string;
  address: string | null;
  telephone: string | null;
  url: string | null;
  notes: string | null;
}

export interface Handle_handle_info_travel_RentalHome {
  __typename: "RentalHome";
  id: string;
  name: string;
  address: string | null;
  notes: string | null;
}

export type Handle_handle_info_travel = Handle_handle_info_travel_EventTravelBookingType | Handle_handle_info_travel_Flight | Handle_handle_info_travel_RentalCar | Handle_handle_info_travel_Taxi | Handle_handle_info_travel_EventTravelNote | Handle_handle_info_travel_Train | Handle_handle_info_travel_Ferry | Handle_handle_info_travel_Shuttle | Handle_handle_info_travel_EventTravelList | Handle_handle_info_travel_Hotel | Handle_handle_info_travel_Tent | Handle_handle_info_travel_RentalHome;

export interface Handle_handle_info_schedule {
  __typename: "EventSchedule";
  id: string;
  name: string;
  description: string | null;
  dressCode: string | null;
  startTime: string | null;
  endTime: string | null;
  timezone: string | null;
  location: string | null;
  showMap: boolean;
  unplugged: boolean;
}

export interface Handle_handle_info {
  __typename: "EventInfo";
  id: string;
  location: string | null;                  // The englicized location of the Main Event
  date: string | null;                      // The date of the Main Event
  greeting: string | null;                  // The greeting shown on this Event's Welcome page
  ownerFirstName: string | null;
  ownerLastName: string | null;
  fianceeFirstName: string | null;
  fianceeLastName: string | null;
  eventDisplayName: string | null;          // The title of this Event
  story: string | null;                     // The couple's story
  qanda: Handle_handle_info_qanda[];        // Q & A information for this Event
  registry: Handle_handle_info_registry[];  // Registry information for this Event
  toBeAnnouncedSchedule: Handle_handle_info_toBeAnnouncedSchedule[];
  formattedSchedule: Handle_handle_info_formattedSchedule[];
  travel: Handle_handle_info_travel[];      // Travel information for this Event
  schedule: Handle_handle_info_schedule[];  // Schedule information for this Event
}

export interface Handle_handle_pages_photo {
  __typename: "Photo";
  id: string;
  url: string;
  width: number;
  height: number;
  assetId: string;
  container: string;  // Identifies the 'container' which holds the Photo.  For a Photo from Firebase, this value is the associated Firebase Event ID.
}

export interface Handle_handle_pages_mobilePhoto {
  __typename: "Photo";
  id: string;
  url: string;
  width: number;
  height: number;
  assetId: string;
  container: string;  // Identifies the 'container' which holds the Photo.  For a Photo from Firebase, this value is the associated Firebase Event ID.
}

export interface Handle_handle_pages {
  __typename: "EventPage";
  id: string;
  type: EventPageType;
  photo: Handle_handle_pages_photo | null;              // The page's avatar Photo on its website
  mobilePhoto: Handle_handle_pages_mobilePhoto | null;  // The page's avatar Photo in the mobile client
  private: boolean;                                     // When `true`, this page is hidden from non-Guests
  disabled: boolean;                                    // When `true`, this page feature has been disabled for this Event
  pageSlug: string;                                     // The URL scroll anchor to this page's section within the Public Website
  pageTitle: string;
  pageSubTitle: string;
}

export interface Handle_handle_style_primaryTextColor {
  __typename: "Color";
  hex: string;
}

export interface Handle_handle_style {
  __typename: "EventStyle";
  id: string;
  layout: Layout;
  accent: string;
  primaryColor: string;
  secondaryColor: string;
  primaryTextColor: Handle_handle_style_primaryTextColor;
  translucent: boolean;
  light: boolean;
  suggestedColor: boolean;
  backgroundType: string | null;
  theme: string;
  border: boolean;
  font: string;
}

export interface Handle_handle_vips_photo {
  __typename: "Photo";
  id: string;
  url: string;
  width: number;
  height: number;
}

export interface Handle_handle_vips {
  __typename: "Vip";
  id: string;
  title: string;
  alias: string | null;                    // An alternate `title` for this V.I.P.
  description: string | null;
  photo: Handle_handle_vips_photo | null;  // The V.I.P.'s avatar Photo
}

export interface Handle_handle {
  __typename: "Event";
  id: string;
  eventId: string;                   // The ID of this Event's Firebase Document
  website: string;                   // The WithJoy URL namespace for this Event, eg. 'withjoy.com/website'
  settings: Handle_handle_settings;  // Settings information for this Event
  info: Handle_handle_info;          // General information for this Event
  pages: Handle_handle_pages[];      // Information for pages displayed by this Event
  style: Handle_handle_style;        // Design & presentational style information for this Event
  vips: Handle_handle_vips[];        // Information for V.I.P.s of this Event
}

export interface Handle {
  handle: Handle_handle | null;
}

export interface HandleVariables {
  handle: string;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: User
// ====================================================

export interface User_user_avatar {
  __typename: "Photo";
  id: string;
  url: string;
  width: number;
  height: number;
  assetId: string;
  container: string;  // Identifies the 'container' which holds the Photo.  For a Photo from Firebase, this value is the associated Firebase Event ID.
}

export interface User_user {
  __typename: "User";
  id: string;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  avatar: User_user_avatar | null;
}

export interface User {
  user: User_user | null;
}

export interface UserVariables {
  id: string;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CurrentUser
// ====================================================

export interface CurrentUser_me_avatar {
  __typename: "Photo";
  id: string;
  url: string;
  width: number;
  height: number;
  assetId: string;
  container: string;  // Identifies the 'container' which holds the Photo.  For a Photo from Firebase, this value is the associated Firebase Event ID.
}

export interface CurrentUser_me_aliases {
  __typename: "UserAlias";
  auth0: string;
  createdAt: string;
}

export interface CurrentUser_me_vendorUsers_vendor {
  __typename: "Vendor";
  id: string;             // UUID of the vendor
  name: string;           // Name of the vendor
  handle: string | null;  // Handle which will be used as the url path and to tag eg: @poppypetalworks
}

export interface CurrentUser_me_vendorUsers {
  __typename: "VendorUser";
  id: string;
  vendor: CurrentUser_me_vendorUsers_vendor;
}

export interface CurrentUser_me_eventUsers_eventV0918 {
  __typename: "Event";
  id: string;
  eventId: string;  // The ID of this Event's Firebase Document
  website: string;  // The WithJoy URL namespace for this Event, eg. 'withjoy.com/website'
}

export interface CurrentUser_me_eventUsers {
  __typename: "EventUser";
  id: string;               // The ID of this User in `event_service.EventUser`
  status: EventUserStatus;  // 'crasher', 'guest', 'owner', etc.
  eventV0918: CurrentUser_me_eventUsers_eventV0918 | null;
}

export interface CurrentUser_me {
  __typename: "User";
  id: string;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  avatar: CurrentUser_me_avatar | null;
  aliases: CurrentUser_me_aliases[];
  vendorUsers: CurrentUser_me_vendorUsers[];
  eventUsers: CurrentUser_me_eventUsers[];
}

export interface CurrentUser {
  me: CurrentUser_me | null;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: VendorTypes
// ====================================================

export interface VendorTypes_vendorTypes {
  __typename: "VendorType";
  id: string;
  type: VendorTypeEnum;
  image: string | null;
  display: string;
}

export interface VendorTypes {
  vendorTypes: VendorTypes_vendorTypes[];
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EventInfoFragment
// ====================================================

export interface EventInfoFragment_qanda {
  __typename: "EventQanda";
  id: string;
  type: QandaType;
  question: string;
  answer: string;
}

export interface EventInfoFragment_registry {
  __typename: "Registry";
  id: string;
  name: string;
  url: string;       // The URL to the Registry website
  imageUrl: string;  // The image to display as the Registry's avatar
}

export interface EventInfoFragment_toBeAnnouncedSchedule {
  __typename: "EventSchedule";
  id: string;
  name: string;
  description: string | null;
  dressCode: string | null;
  location: string | null;
  showMap: boolean;
  placeId: string | null;
  startTime: string | null;
  endTime: string | null;
}

export interface EventInfoFragment_formattedSchedule_items {
  __typename: "EventSchedule";
  id: string;
  name: string;
  description: string | null;
  dressCode: string | null;
  startTime: string | null;
  endTime: string | null;
  timezone: string | null;
  location: string | null;
  showMap: boolean;
}

export interface EventInfoFragment_formattedSchedule {
  __typename: "FormattedSchedule";
  day: number;
  month: number;
  year: number;
  date: string;
  dateString: string;
  items: EventInfoFragment_formattedSchedule_items[];
}

export interface EventInfoFragment_travel_EventTravelBookingType {
  __typename: "EventTravelBookingType";
  id: string;
  name: string;
  address: string | null;
  bookingType: string | null;
  startDate: string | null;
  endDate: string | null;
  timezone: string | null;
  latitude: number | null;
  longitude: number | null;
  placeId: string | null;
}

export interface EventInfoFragment_travel_Flight {
  __typename: "Flight";
  id: string;
  name: string;
  url: string | null;
  code: string | null;
  notes: string | null;
}

export interface EventInfoFragment_travel_RentalCar {
  __typename: "RentalCar";
  id: string;
  name: string;
  address: string | null;
  telephone: string | null;
  notes: string | null;
  url: string | null;
}

export interface EventInfoFragment_travel_Taxi {
  __typename: "Taxi";
  id: string;
  name: string;
  address: string | null;
  telephone: string | null;
  notes: string | null;
  url: string | null;
}

export interface EventInfoFragment_travel_EventTravelNote {
  __typename: "EventTravelNote";
  id: string;
  name: string;
  notes: string | null;
}

export interface EventInfoFragment_travel_Train {
  __typename: "Train";
  id: string;
  name: string;
  address: string | null;
  telephone: string | null;
  notes: string | null;
  url: string | null;
}

export interface EventInfoFragment_travel_Ferry {
  __typename: "Ferry";
  id: string;
  name: string;
  address: string | null;
  telephone: string | null;
  url: string | null;
  notes: string | null;
}

export interface EventInfoFragment_travel_Shuttle_items {
  __typename: "ShuttleItem";
  id: string;
  note: string | null;
  dateStart: string | null;
  dateEnd: string | null;
}

export interface EventInfoFragment_travel_Shuttle {
  __typename: "Shuttle";
  id: string;
  name: string;
  notes: string | null;
  items: EventInfoFragment_travel_Shuttle_items[];
}

export interface EventInfoFragment_travel_EventTravelList_items {
  __typename: "EventTravelListItem";
  id: string;
  title: string | null;
  url: string | null;
}

export interface EventInfoFragment_travel_EventTravelList {
  __typename: "EventTravelList";
  id: string;
  name: string;
  items: EventInfoFragment_travel_EventTravelList_items[];
}

export interface EventInfoFragment_travel_Hotel {
  __typename: "Hotel";
  id: string;
  name: string;
  address: string | null;
  telephone: string | null;
  url: string | null;
  notes: string | null;
}

export interface EventInfoFragment_travel_Tent {
  __typename: "Tent";
  id: string;
  name: string;
  address: string | null;
  telephone: string | null;
  url: string | null;
  notes: string | null;
}

export interface EventInfoFragment_travel_RentalHome {
  __typename: "RentalHome";
  id: string;
  name: string;
  address: string | null;
  notes: string | null;
}

export type EventInfoFragment_travel = EventInfoFragment_travel_EventTravelBookingType | EventInfoFragment_travel_Flight | EventInfoFragment_travel_RentalCar | EventInfoFragment_travel_Taxi | EventInfoFragment_travel_EventTravelNote | EventInfoFragment_travel_Train | EventInfoFragment_travel_Ferry | EventInfoFragment_travel_Shuttle | EventInfoFragment_travel_EventTravelList | EventInfoFragment_travel_Hotel | EventInfoFragment_travel_Tent | EventInfoFragment_travel_RentalHome;

export interface EventInfoFragment {
  __typename: "EventInfo";
  id: string;
  location: string | null;                 // The englicized location of the Main Event
  date: string | null;                     // The date of the Main Event
  greeting: string | null;                 // The greeting shown on this Event's Welcome page
  ownerFirstName: string | null;
  ownerLastName: string | null;
  fianceeFirstName: string | null;
  fianceeLastName: string | null;
  eventDisplayName: string | null;         // The title of this Event
  story: string | null;                    // The couple's story
  qanda: EventInfoFragment_qanda[];        // Q & A information for this Event
  registry: EventInfoFragment_registry[];  // Registry information for this Event
  toBeAnnouncedSchedule: EventInfoFragment_toBeAnnouncedSchedule[];
  formattedSchedule: EventInfoFragment_formattedSchedule[];
  travel: EventInfoFragment_travel[];      // Travel information for this Event
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: TravelFragment
// ====================================================

export interface TravelFragment_travel_EventTravelBookingType {
  __typename: "EventTravelBookingType";
  id: string;
  name: string;
  address: string | null;
  bookingType: string | null;
  startDate: string | null;
  endDate: string | null;
  timezone: string | null;
  latitude: number | null;
  longitude: number | null;
  placeId: string | null;
}

export interface TravelFragment_travel_Flight {
  __typename: "Flight";
  id: string;
  name: string;
  url: string | null;
  code: string | null;
  notes: string | null;
}

export interface TravelFragment_travel_RentalCar {
  __typename: "RentalCar";
  id: string;
  name: string;
  address: string | null;
  telephone: string | null;
  notes: string | null;
  url: string | null;
}

export interface TravelFragment_travel_Taxi {
  __typename: "Taxi";
  id: string;
  name: string;
  address: string | null;
  telephone: string | null;
  notes: string | null;
  url: string | null;
}

export interface TravelFragment_travel_EventTravelNote {
  __typename: "EventTravelNote";
  id: string;
  name: string;
  notes: string | null;
}

export interface TravelFragment_travel_Train {
  __typename: "Train";
  id: string;
  name: string;
  address: string | null;
  telephone: string | null;
  notes: string | null;
  url: string | null;
}

export interface TravelFragment_travel_Ferry {
  __typename: "Ferry";
  id: string;
  name: string;
  address: string | null;
  telephone: string | null;
  url: string | null;
  notes: string | null;
}

export interface TravelFragment_travel_Shuttle_items {
  __typename: "ShuttleItem";
  id: string;
  note: string | null;
  dateStart: string | null;
  dateEnd: string | null;
}

export interface TravelFragment_travel_Shuttle {
  __typename: "Shuttle";
  id: string;
  name: string;
  notes: string | null;
  items: TravelFragment_travel_Shuttle_items[];
}

export interface TravelFragment_travel_EventTravelList_items {
  __typename: "EventTravelListItem";
  id: string;
  title: string | null;
  url: string | null;
}

export interface TravelFragment_travel_EventTravelList {
  __typename: "EventTravelList";
  id: string;
  name: string;
  items: TravelFragment_travel_EventTravelList_items[];
}

export interface TravelFragment_travel_Hotel {
  __typename: "Hotel";
  id: string;
  name: string;
  address: string | null;
  telephone: string | null;
  url: string | null;
  notes: string | null;
}

export interface TravelFragment_travel_Tent {
  __typename: "Tent";
  id: string;
  name: string;
  address: string | null;
  telephone: string | null;
  url: string | null;
  notes: string | null;
}

export interface TravelFragment_travel_RentalHome {
  __typename: "RentalHome";
  id: string;
  name: string;
  address: string | null;
  notes: string | null;
}

export type TravelFragment_travel = TravelFragment_travel_EventTravelBookingType | TravelFragment_travel_Flight | TravelFragment_travel_RentalCar | TravelFragment_travel_Taxi | TravelFragment_travel_EventTravelNote | TravelFragment_travel_Train | TravelFragment_travel_Ferry | TravelFragment_travel_Shuttle | TravelFragment_travel_EventTravelList | TravelFragment_travel_Hotel | TravelFragment_travel_Tent | TravelFragment_travel_RentalHome;

export interface TravelFragment {
  __typename: "EventInfo";
  travel: TravelFragment_travel[];  // Travel information for this Event
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ScheduleFragment
// ====================================================

export interface ScheduleFragment_schedule {
  __typename: "EventSchedule";
  id: string;
  name: string;
  description: string | null;
  dressCode: string | null;
  startTime: string | null;
  endTime: string | null;
  timezone: string | null;
  location: string | null;
  showMap: boolean;
  unplugged: boolean;
}

export interface ScheduleFragment {
  __typename: "EventInfo";
  schedule: ScheduleFragment_schedule[];  // Schedule information for this Event
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: GuestSitePagesFragment
// ====================================================

export interface GuestSitePagesFragment_pages_photo {
  __typename: "Photo";
  id: string;
  url: string;
  width: number;
  height: number;
  assetId: string;
  container: string;  // Identifies the 'container' which holds the Photo.  For a Photo from Firebase, this value is the associated Firebase Event ID.
}

export interface GuestSitePagesFragment_pages_mobilePhoto {
  __typename: "Photo";
  id: string;
  url: string;
  width: number;
  height: number;
  assetId: string;
  container: string;  // Identifies the 'container' which holds the Photo.  For a Photo from Firebase, this value is the associated Firebase Event ID.
}

export interface GuestSitePagesFragment_pages {
  __typename: "EventPage";
  id: string;
  type: EventPageType;
  photo: GuestSitePagesFragment_pages_photo | null;              // The page's avatar Photo on its website
  mobilePhoto: GuestSitePagesFragment_pages_mobilePhoto | null;  // The page's avatar Photo in the mobile client
  private: boolean;                                              // When `true`, this page is hidden from non-Guests
  disabled: boolean;                                             // When `true`, this page feature has been disabled for this Event
  pageSlug: string;                                              // The URL scroll anchor to this page's section within the Public Website
  pageTitle: string;
  pageSubTitle: string;
}

export interface GuestSitePagesFragment {
  __typename: "Event";
  pages: GuestSitePagesFragment_pages[];  // Information for pages displayed by this Event
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: StyleFragment
// ====================================================

export interface StyleFragment_style_primaryTextColor {
  __typename: "Color";
  hex: string;
}

export interface StyleFragment_style {
  __typename: "EventStyle";
  id: string;
  layout: Layout;
  accent: string;
  primaryColor: string;
  secondaryColor: string;
  primaryTextColor: StyleFragment_style_primaryTextColor;
  translucent: boolean;
  light: boolean;
  suggestedColor: boolean;
  backgroundType: string | null;
  theme: string;
  border: boolean;
  font: string;
}

export interface StyleFragment {
  __typename: "Event";
  style: StyleFragment_style;  // Design & presentational style information for this Event
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: VipFragment
// ====================================================

export interface VipFragment_photo {
  __typename: "Photo";
  id: string;
  url: string;
  width: number;
  height: number;
}

export interface VipFragment {
  __typename: "Vip";
  id: string;
  title: string;
  alias: string | null;             // An alternate `title` for this V.I.P.
  description: string | null;
  photo: VipFragment_photo | null;  // The V.I.P.'s avatar Photo
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EventFragment
// ====================================================

export interface EventFragment_settings {
  __typename: "EventSettings";
  hideEventCountdown: boolean;
}

export interface EventFragment_info_qanda {
  __typename: "EventQanda";
  id: string;
  type: QandaType;
  question: string;
  answer: string;
}

export interface EventFragment_info_registry {
  __typename: "Registry";
  id: string;
  name: string;
  url: string;       // The URL to the Registry website
  imageUrl: string;  // The image to display as the Registry's avatar
}

export interface EventFragment_info_toBeAnnouncedSchedule {
  __typename: "EventSchedule";
  id: string;
  name: string;
  description: string | null;
  dressCode: string | null;
  location: string | null;
  showMap: boolean;
  placeId: string | null;
  startTime: string | null;
  endTime: string | null;
}

export interface EventFragment_info_formattedSchedule_items {
  __typename: "EventSchedule";
  id: string;
  name: string;
  description: string | null;
  dressCode: string | null;
  startTime: string | null;
  endTime: string | null;
  timezone: string | null;
  location: string | null;
  showMap: boolean;
}

export interface EventFragment_info_formattedSchedule {
  __typename: "FormattedSchedule";
  day: number;
  month: number;
  year: number;
  date: string;
  dateString: string;
  items: EventFragment_info_formattedSchedule_items[];
}

export interface EventFragment_info_travel_EventTravelBookingType {
  __typename: "EventTravelBookingType";
  id: string;
  name: string;
  address: string | null;
  bookingType: string | null;
  startDate: string | null;
  endDate: string | null;
  timezone: string | null;
  latitude: number | null;
  longitude: number | null;
  placeId: string | null;
}

export interface EventFragment_info_travel_Flight {
  __typename: "Flight";
  id: string;
  name: string;
  url: string | null;
  code: string | null;
  notes: string | null;
}

export interface EventFragment_info_travel_RentalCar {
  __typename: "RentalCar";
  id: string;
  name: string;
  address: string | null;
  telephone: string | null;
  notes: string | null;
  url: string | null;
}

export interface EventFragment_info_travel_Taxi {
  __typename: "Taxi";
  id: string;
  name: string;
  address: string | null;
  telephone: string | null;
  notes: string | null;
  url: string | null;
}

export interface EventFragment_info_travel_EventTravelNote {
  __typename: "EventTravelNote";
  id: string;
  name: string;
  notes: string | null;
}

export interface EventFragment_info_travel_Train {
  __typename: "Train";
  id: string;
  name: string;
  address: string | null;
  telephone: string | null;
  notes: string | null;
  url: string | null;
}

export interface EventFragment_info_travel_Ferry {
  __typename: "Ferry";
  id: string;
  name: string;
  address: string | null;
  telephone: string | null;
  url: string | null;
  notes: string | null;
}

export interface EventFragment_info_travel_Shuttle_items {
  __typename: "ShuttleItem";
  id: string;
  note: string | null;
  dateStart: string | null;
  dateEnd: string | null;
}

export interface EventFragment_info_travel_Shuttle {
  __typename: "Shuttle";
  id: string;
  name: string;
  notes: string | null;
  items: EventFragment_info_travel_Shuttle_items[];
}

export interface EventFragment_info_travel_EventTravelList_items {
  __typename: "EventTravelListItem";
  id: string;
  title: string | null;
  url: string | null;
}

export interface EventFragment_info_travel_EventTravelList {
  __typename: "EventTravelList";
  id: string;
  name: string;
  items: EventFragment_info_travel_EventTravelList_items[];
}

export interface EventFragment_info_travel_Hotel {
  __typename: "Hotel";
  id: string;
  name: string;
  address: string | null;
  telephone: string | null;
  url: string | null;
  notes: string | null;
}

export interface EventFragment_info_travel_Tent {
  __typename: "Tent";
  id: string;
  name: string;
  address: string | null;
  telephone: string | null;
  url: string | null;
  notes: string | null;
}

export interface EventFragment_info_travel_RentalHome {
  __typename: "RentalHome";
  id: string;
  name: string;
  address: string | null;
  notes: string | null;
}

export type EventFragment_info_travel = EventFragment_info_travel_EventTravelBookingType | EventFragment_info_travel_Flight | EventFragment_info_travel_RentalCar | EventFragment_info_travel_Taxi | EventFragment_info_travel_EventTravelNote | EventFragment_info_travel_Train | EventFragment_info_travel_Ferry | EventFragment_info_travel_Shuttle | EventFragment_info_travel_EventTravelList | EventFragment_info_travel_Hotel | EventFragment_info_travel_Tent | EventFragment_info_travel_RentalHome;

export interface EventFragment_info_schedule {
  __typename: "EventSchedule";
  id: string;
  name: string;
  description: string | null;
  dressCode: string | null;
  startTime: string | null;
  endTime: string | null;
  timezone: string | null;
  location: string | null;
  showMap: boolean;
  unplugged: boolean;
}

export interface EventFragment_info {
  __typename: "EventInfo";
  id: string;
  location: string | null;                  // The englicized location of the Main Event
  date: string | null;                      // The date of the Main Event
  greeting: string | null;                  // The greeting shown on this Event's Welcome page
  ownerFirstName: string | null;
  ownerLastName: string | null;
  fianceeFirstName: string | null;
  fianceeLastName: string | null;
  eventDisplayName: string | null;          // The title of this Event
  story: string | null;                     // The couple's story
  qanda: EventFragment_info_qanda[];        // Q & A information for this Event
  registry: EventFragment_info_registry[];  // Registry information for this Event
  toBeAnnouncedSchedule: EventFragment_info_toBeAnnouncedSchedule[];
  formattedSchedule: EventFragment_info_formattedSchedule[];
  travel: EventFragment_info_travel[];      // Travel information for this Event
  schedule: EventFragment_info_schedule[];  // Schedule information for this Event
}

export interface EventFragment_pages_photo {
  __typename: "Photo";
  id: string;
  url: string;
  width: number;
  height: number;
  assetId: string;
  container: string;  // Identifies the 'container' which holds the Photo.  For a Photo from Firebase, this value is the associated Firebase Event ID.
}

export interface EventFragment_pages_mobilePhoto {
  __typename: "Photo";
  id: string;
  url: string;
  width: number;
  height: number;
  assetId: string;
  container: string;  // Identifies the 'container' which holds the Photo.  For a Photo from Firebase, this value is the associated Firebase Event ID.
}

export interface EventFragment_pages {
  __typename: "EventPage";
  id: string;
  type: EventPageType;
  photo: EventFragment_pages_photo | null;              // The page's avatar Photo on its website
  mobilePhoto: EventFragment_pages_mobilePhoto | null;  // The page's avatar Photo in the mobile client
  private: boolean;                                     // When `true`, this page is hidden from non-Guests
  disabled: boolean;                                    // When `true`, this page feature has been disabled for this Event
  pageSlug: string;                                     // The URL scroll anchor to this page's section within the Public Website
  pageTitle: string;
  pageSubTitle: string;
}

export interface EventFragment_style_primaryTextColor {
  __typename: "Color";
  hex: string;
}

export interface EventFragment_style {
  __typename: "EventStyle";
  id: string;
  layout: Layout;
  accent: string;
  primaryColor: string;
  secondaryColor: string;
  primaryTextColor: EventFragment_style_primaryTextColor;
  translucent: boolean;
  light: boolean;
  suggestedColor: boolean;
  backgroundType: string | null;
  theme: string;
  border: boolean;
  font: string;
}

export interface EventFragment_vips_photo {
  __typename: "Photo";
  id: string;
  url: string;
  width: number;
  height: number;
}

export interface EventFragment_vips {
  __typename: "Vip";
  id: string;
  title: string;
  alias: string | null;                    // An alternate `title` for this V.I.P.
  description: string | null;
  photo: EventFragment_vips_photo | null;  // The V.I.P.'s avatar Photo
}

export interface EventFragment {
  __typename: "Event";
  id: string;
  eventId: string;                   // The ID of this Event's Firebase Document
  website: string;                   // The WithJoy URL namespace for this Event, eg. 'withjoy.com/website'
  settings: EventFragment_settings;  // Settings information for this Event
  info: EventFragment_info;          // General information for this Event
  pages: EventFragment_pages[];      // Information for pages displayed by this Event
  style: EventFragment_style;        // Design & presentational style information for this Event
  vips: EventFragment_vips[];        // Information for V.I.P.s of this Event
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PhotoFragment
// ====================================================

export interface PhotoFragment {
  __typename: "Photo";
  id: string;
  url: string;
  width: number;
  height: number;
  assetId: string;
  container: string;  // Identifies the 'container' which holds the Photo.  For a Photo from Firebase, this value is the associated Firebase Event ID.
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UserFragment
// ====================================================

export interface UserFragment_avatar {
  __typename: "Photo";
  id: string;
  url: string;
  width: number;
  height: number;
  assetId: string;
  container: string;  // Identifies the 'container' which holds the Photo.  For a Photo from Firebase, this value is the associated Firebase Event ID.
}

export interface UserFragment {
  __typename: "User";
  id: string;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  avatar: UserFragment_avatar | null;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: VendorFragment
// ====================================================

export interface VendorFragment_photo {
  __typename: "Photo";
  id: string;
  url: string;
  width: number;
  height: number;
}

export interface VendorFragment {
  __typename: "Vendor";
  id: string;                  // UUID of the vendor
  name: string;                // Name of the vendor
  handle: string | null;       // Handle which will be used as the url path and to tag eg: @poppypetalworks
  description: string | null;  // Short description of the vendor and capabilities
  email: string | null;        // Comapny email of the vendor
  photo: VendorFragment_photo | null;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: VendorTypeFragment
// ====================================================

export interface VendorTypeFragment {
  __typename: "VendorType";
  id: string;
  type: VendorTypeEnum;
  image: string | null;
  display: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum QandaType {
  faq = "faq",
  tidbit = "tidbit",
}

export enum Layout {
  aloha = "aloha",
  brannan = "brannan",
  harrison = "harrison",
  hennepin = "hennepin",
}

export enum EventPageType {
  custom = "custom",
  faq = "faq",
  guests = "guests",
  moments = "moments",
  registry = "registry",
  rsvp = "rsvp",
  schedule = "schedule",
  story = "story",
  travel = "travel",
  vip = "vip",
  welcome = "welcome",
}

export enum EventUserStatus {
  admin = "admin",
  crasher = "crasher",
  guest = "guest",
  owner = "owner",
}

export enum VendorTypeEnum {
  catering = "catering",
  dessert = "dessert",
  djs = "djs",
  florist = "florist",
  makeup = "makeup",
  misc = "misc",
  officiants = "officiants",
  photo = "photo",
  planners = "planners",
  rental = "rental",
  transport = "transport",
  venue = "venue",
  video = "video",
}

// null
export interface CalendarDate {
  year: number;
  month: number;
  dayOfMonth: number;
}

//==============================================================
// END Enums and Input Objects
//==============================================================